import { __decorate } from "tslib";
import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { EN_LOCAL } from '@/helpers/locale';
import { checkIsValid } from '@/components/forms/attributes/helpers';
const CommonStore = namespace('CommonStore');
let DynamicFormMixin = class DynamicFormMixin extends Vue {
    accountData;
    schema = [];
    get isErrorInForm() {
        return this.prepareAttributeSchema.some(item => !item.isValid);
    }
    get currentLangKey() {
        return this.$i18n.locale === EN_LOCAL ? `en_name` : `localized_name`;
    }
    get prepareAttributeSchema() {
        if (!this.schema || this.schema.length === 0) {
            return [];
        }
        return this.schema.map(item => ({
            ...item,
            className: this.schemaClass || `b-booking-form__input-wrapper`,
            value: item.value || ``,
            title: item[this.currentLangKey] || ``,
            isValid: checkIsValid(item),
        }));
    }
    updateSchema(schema) {
        this.schema = schema;
    }
};
__decorate([
    CommonStore.State('accountData')
], DynamicFormMixin.prototype, "accountData", void 0);
DynamicFormMixin = __decorate([
    Component
], DynamicFormMixin);
export default DynamicFormMixin;
;
